export enum BankTransactionType {
  Deposit = 1,
  Withdraw,
  Transfer
}
